class LocalePopup extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.closeButton = this.querySelector('.locale-popup__close');
    this.overlay = this.querySelector('.locale-popup__overlay');
    // this.saveButton = this.querySelector('.locale-popup__save');
    this.countryForm = this.querySelector('#LocalePopupForm');
    this.languageForm = this.querySelector('#LocalePopupLanguageForm');

    this.bindEvents();
  }

  bindEvents() {
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    // this.saveButton.addEventListener('click', () => this.save());

    // Close on escape key
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.removeAttribute('open');
    this.isOpen = false;
    document.body.style.overflow = '';
  }

  save() {
    // Submit both forms
    const countryCode = this.countryForm.querySelector('input[name="country_code"]:checked').value;
    const languageCode = this.languageForm.querySelector('input[name="language_code"]:checked').value;

    // Update hidden inputs
    this.countryForm.querySelector('input[name="country_code"]').value = countryCode;
    this.languageForm.querySelector('input[name="language_code"]').value = languageCode;

    // Submit forms
    Promise.all([
      new Promise((resolve) => {
        this.countryForm.submit();
        resolve();
      }),
      new Promise((resolve) => {
        this.languageForm.submit();
        resolve();
      })
    ]).then(() => {
      this.close();
      // Reload page to reflect changes
      window.location.reload();
    });
  }
}

// Define the custom element
customElements.define('locale-popup', LocalePopup);

// Helper function to toggle the popup from a trigger button
function initLocalePopupTrigger() {
  const triggers = document.querySelectorAll('[data-locale-popup-trigger]');
  const popup = document.querySelector('locale-popup');

  if (!popup || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      popup.open();
    });
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initLocalePopupTrigger); 